import './Navbar.scss'
const Navbar = () => {
    return (
        <div className="container-fluid navbar fixed-top navbar--style">
            <div className="container-fluid row">
                <div className='d-flex align-items-center'>
                    <div className='col text-end'>
                        <img className='logo--mpp' src='./img/logo-mpp.png' />
                    </div>
                    <div className='col-8 text-start'>
                        <p className='aller--light m-0'>Manual para padres de ni&ntilde;os prematuros</p>
                    </div>
                    <div className='col text-start d-none d-md-block'>
                        <img className='logo--astrazeneza' src="./img/logo-astrazeneca.png" alt='Logo AstraZeneca' />
                    </div>

                    <button
                        className="navbar-toggler d-block d-sm-block d-md-none bg-white text-white button--toggle "
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#id--sidebar"
                        aria-controls="id--sidebar"
                        aria-expanded="false"
                        // oncClick={() => setIsOpen(prev => !prev)}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    {/* collapse */}
                </div>
            </div>
        </div>
    )
}

export default Navbar;